// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import moment from "moment-timezone"

class Section extends Model {
  defaults() {
    return {
      id: null,
      spaces: null,
      registrations_count: null,
      automatically_applied: false,
      section_options: [],
      _destroy: false,
      starts_at: null,
      ends_at: null,
      starts_at_str: null,
      ends_at_str: null,
    }
  }

  mutations() {
    return {
      starts_at: (str) => typeof str === 'string' ? str.split("T")[0] : str,
      ends_at:   (str) => typeof str === 'string' ? str.split("T")[0] : str,
    }
  }

  // source: (spaces.try(:to_i) || Float::INFINITY) - registrations_count.to_i
  available_spaces(){
    if (this._available_spaces) return this._available_spaces
    return this._available_spaces = (this.spaces || Infinity) - (this.registrations_count||0)
  }

  has_spaces(){
    if (!this.id) return true
    return this.spaces === null || this.spaces > this.registrations_count
  }
  no_spaces(){
    return !this.has_spaces()
  }

  limitation_visible() {
    return isPresent(this.grade_from)
        || isPresent(this.grade_until)
        || isPresent(this.age_date_from_year)
        || isPresent(this.age_date_until_year)
        || isPresent(this.age_date_from_month)
        || isPresent(this.age_date_until_month)
        || isPresent(this.age_limitation_at)
  }
  valid_today(){
    return (!this.is_active_dates() || this.today_in_dates())
  }
  is_active_dates(){
    return this.active_dates || this.valid_from || this.valid_until
  }
  today_in_dates(){
    const now = moment().unix()
    if (this.valid_from && this.valid_until)
      return moment(this.valid_from).unix() < now && now < moment(this.valid_until).unix()
    else if (this.valid_until)
      return now < moment(this.valid_until).unix()
    else if (this.valid_from)
      return now > moment(this.valid_from).unix()
    else
      return true
  }
}

export {
  Section
}
